import { cardBio } from "../modules/cards/cardsBio";
import mobileCarousel from "../modules/utils/mobileCarousel";

cardBio();

mobileCarousel('section-persons__persons-row', 'section-persons__arrow', 1.4, 8, false);